import React, { useState, useEffect, useContext } from "react";
import config from "../../config/config";
import axios from "axios";
import { AppContext } from "../../context/AppContext";
import CustomDropdown from "../common/CustomDropdown";
import check from "../../images/check1.jpg";
import noImage from "../../images/no_image.jpg";
import { projectValidation } from "../validations/CustomValidations";
import { useNavigate, useParams } from 'react-router-dom';
import { sendWhatsappMessageApi } from "../../api/commonApi";


const AddProject = () => {
  const { loggedIN } = useContext(AppContext);
  const navigate = useNavigate();
  const token = config.getAuthToken();
  const steps = [
    "Add Project Details",
    "Add Photos/Videos",
    "Verify Your Property",
  ];
  const { user } = useContext(AppContext);
  const cityOptions = [{ value: "1", label: "Jaipur" }];
  const stateOptions = [{ value: "1", label: "Rajasthan" }];
  const categoryOptions = [
    { value: "Project", label: "Project" },
    { value: "Building", label: "Building" },
    { value: "Society", label: "Society" },
  ];
  const unitOptions = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
  ];
  const [localityInput, setLocalityInput] = useState("");
  const [localities, setLocalities] = useState([]);
  const [areaUnitInput, setAreaUnitInput] = useState("");
  const [areaUnit, setAreaUnit] = useState([]);
  const [showAreaUnitDropdown, setShowAreaUnitDropdown] = useState(false);
  const [loadingAreaUnit, setLoadingAreaUnit] = useState(false);
  const [loadingLocalities, setLoadingLocalities] = useState(false);
  const [showLocalityDropdown, setShowLocalityDropdown] = useState(false);

  const { projectId } = useParams();
  const [apiData, setApiData] = useState([]);
  const [emitterEvent, setEmitterEvent] = useState(false);

  useEffect(() => {
      const fetchData = async () => {
        try {
          if (projectId && user?.data?.id) {
            const formData = new FormData();
            formData.append('user_id', user?.data?.id);
            const response = await axios.post(
              `${process.env.REACT_APP_BASE_URL}/myProjectList/${projectId}`,
              formData,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );
            setApiData(response.data.data);
            setEmitterEvent(true);
          }
        } catch (error) {
          console.error("API Error:", error);
        }
      };
  
      fetchData();
    }, [projectId, user?.data?.id]);
 
  useEffect(() => {
    handleInputChange("projectDetails", "userId", user?.data?.id);
  }, [user]);
  const [activeStep, setActiveStep] = useState(0);
  const [images, setImages] = useState([]);
  const [errors, setErrors] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [formData, setFormData] = useState({
    projectDetails: {
      id: "",
      userId: "",
      projectName: "",
      category: "",
      city: "1",
      state: "1",
      launchDate: "",
      projectArea: "",
      locality: "",
      sub_locality: "",
      projectDescription: "",
      reraId: "",
      totalUnit: "",
      reminder_time:"",
      reminder_date:"",
      areaUnit:""
    },
  });
  const handleInputChange = (step, field, value, priceIndex = null) => {
    if (step === "roomDetail" && priceIndex !== null) {
      setFormData((prev) => ({
        ...prev,
        [step]: {
          ...prev[step],
          [priceIndex]: {
            ...(prev[step]?.[priceIndex] || {}), // Preserve existing data at this index
            [field]: value, // Push new field-value
          },
        },
      }));

      setErrors((prev) => ({
        ...prev,
        [step]: {
          ...(prev[step] || {}),
          [priceIndex]: {
            ...(prev[step]?.[priceIndex] || {}),
            [field]: "", // Clear error for the specific field
          },
        },
      }));

      console.log(formData);
    } else {
      setFormData((prev) => ({
        ...prev,
        [step]: {
          ...prev[step],
          [field]: value,
        },
      }));
      setErrors((prev) => ({
        ...prev,
        [field]: "", // Clear error for the field being modified
      }));

      
    }
  };
  const handleNextStep = (index) => {
   
  
    if (index < activeStep) {
      setActiveStep(index);
      // alert here still shows the old value because state hasn't updated yet
      return;
    } else if (index > activeStep) {
      return;
    }
  };
  
  useEffect(() => {

  }, [activeStep]);
  const handleDelete = async (index, imageId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/deleteProjectImage`,
        {
          method: "POST", // Use POST if DELETE is not supported
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ image_id: imageId }),
        }
      );

      const result = await response.json();
      console.log(result);

      if (result.status) {
        // Remove the deleted image from state
        setImages((prevImages) => prevImages.filter((_, i) => i !== index));
      } else {
        alert("Failed to delete image!");
      }
    } catch (error) {
      console.error("Error deleting image:", error);
    }
  };
  // Handle file selection
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    uploadImages(files);
  };

  // Handle drag-over event
  const handleDragOver = (e) => {
    e.preventDefault();
  };

  // Handle drop event
  const handleDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    uploadImages(files);
  };

  // Handle delete image
  const handleCategory = async (imageId, value) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/imageCategory`,
        {
          method: "POST", // Use POST if DELETE is not supported
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ image_id: imageId, category: value }),
        }
      );

      const result = await response.json();
      console.log(result);

      if (result.status) {
        // Remove the deleted image from state
        console.error("Category Save");
      } else {
        alert("Failed to save category!");
      }
    } catch (error) {
      console.error("Error save category:", error);
    }
  };

  const uploadImages = async (files) => {
    const formImageData = new FormData();
    files.forEach((file) => formImageData.append("images[]", file));
    formImageData.append("property_id", formData.projectDetails.id);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/uploadProjectImages`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formImageData,
        }
      );

      const result = await response.json();

      if (result.status) {
        setImages((prevImages) => [...prevImages, ...result.data]);
      } else if (!result.status) {
        alert("something went wrong");
      }
    } catch (error) {
      console.error("Error uploading images:", error);
    }
  };


   useEffect(() => {
      if (apiData && Object.keys(apiData).length !== 0) {
        setFormData((prev) => ({
          ...prev,projectDetails: {
            ...prev.projectDetails,
            id: apiData.id || '',
            projectName: apiData.name || '',
            category: apiData.category || '',
            sub_locality: apiData.sub_location || '',
            locality: apiData.location || '',
            projectDescription: apiData.description || '',
            totalUnit: apiData.totalUnit || '',
            areaUnit: apiData.area_unit || '',
            launchDate: apiData.launch_date || '',
            reraId: apiData.rera_id || '',
            reminder_date: apiData.reminder_date || '',
            reminder_time: apiData.reminder_time || '',
            projectArea: apiData.area || '',
          },
        }));
      }
  
      setLocalityInput(apiData?.locality || '')
      setAreaUnitInput(apiData?.area_unit_name || '')
    }, [apiData]);



  const handleSubmitDetail = async (e) => {
    if (e) e.preventDefault(); // Prevent default form submission// Prevent default form submission behavior
    // Validate input fields
    const validationErrors = projectValidation(formData);
    //alert(validationErrors);
    setErrors(validationErrors);

    // If errors exist, return early
    if (Object.keys(validationErrors).length > 0) {
      return;
    }
    const apiName = projectId ? 'updateProject' : 'addProjectDetail';
    try {
      // API request
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/${apiName}`,
        formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        });

      if (response.status === 201) {
        // alert("Project added successfully");
        handleInputChange("projectDetails", "id", response.data.id);
        setActiveStep(1);

        loggedIN(token, user);


                if(user?.data?.mobile)
                  {
              await sendWhatsappMessageApi({
                   slug: 'user_post_project',
                   mobile: user?.data?.mobile,
                   name: user?.data?.name || 'Seller',
                   title: response.data?.title,
                   location: response.data?.location,
                   token: token,
               
                 });
                }
      }
      else if (response.status === 200) {

        if(projectId){
          // alert('hello');
          setActiveStep(1);
          // alert('Image');
          await sendWhatsappMessageApi({
            slug: 'user_update_project',
            mobile: user?.data?.mobile,
            name: user?.data?.name || 'Seller',
            title: response.data?.title,
            location: response.data?.location,
            token: token,
        
          });
          
        }
        // Update user object
        if (user?.data) {
          user.data.project_count = 1;


          loggedIN(token, user);
          setActiveStep(1);
        }
      }

      else {
        setErrors({ general: "Failed to add property. Please try again." });
      }
    } catch (error) {
      console.error("Property Add error:", error);
      setErrors({ general: "An error occurred. Please try again later." });
    }
  };


  
    const getProjectImages = async () => {
  
      const formImageData = new FormData();
      formImageData.append("project_id", projectId);
      formImageData.append("user_id", user?.data?.id);
  
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/getProjectImages`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formImageData,
        });
  
        const result = await response.json();
  
        if (result.status) {
          setImages(result.data);
  
        }
        else if (!result.status) {
          alert('something went wrong')
        }
      } catch (error) {
        console.error("Error uploading images:", error);
      }
    };
  
  
    useEffect(() => {
      getProjectImages()
    }, [projectId]);


  
  const handleSkip = () => {
    // alert("skip");
    if(projectId){
      navigate('/myProfile?value=myProjects');
    }else{
    setActiveStep(2);
    }
  };
    const [reminderErrors, setReminderErrors] = useState({});
  const handleSetReminderSubmit = async (e) => {
    if (e) e.preventDefault();

    const { reminder_date, reminder_time } = formData.projectDetails;
    const newReminderErrors = {};

    if (!reminder_date) {
      newReminderErrors.reminder_date = "Please select a reminder date.";
    }

    if (!reminder_time) {
      newReminderErrors.reminder_time = "Please select a reminder time.";
    }

    if (reminder_date && reminder_time) {
      const selectedDateTime = new Date(`${reminder_date}T${reminder_time}`);
      const now = new Date();

      if (selectedDateTime < now) {
        newReminderErrors.reminder_time = "Reminder date and time cannot be in the past.";
      }
    }

    if (Object.keys(newReminderErrors).length > 0) {
      setReminderErrors(newReminderErrors);
      return;
    }

    // Clear errors and proceed
    setReminderErrors({});


    handleSubmitDetail();
    setShowPopup(true);
    setTimeout(() => {
      setShowPopup(false);
    }, 5000);
    navigate('/myProfile?value=myProjects');
  };
  const handleLocalityInputChange = (e) => {
    setLocalityInput(e.target.value);
    setShowLocalityDropdown(true);
  };

  const handleLocalitySelect = (locality) => {
    setLocalityInput(locality.name);
    handleInputChange("projectDetails", "sub_locality", locality.id);
    handleInputChange("projectDetails", "locality", locality.locality_id);
    setShowLocalityDropdown(false); // Hide dropdown after selection
  };

  useEffect(() => {
    setLoadingLocalities(true);
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/search/localities?query=${localityInput}&city_id=1`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Get token from localStorage
          },
        }
      )
      .then((response) => {
        setLocalities(response.data.data || []);
      })
      .catch((error) => console.error("Error fetching localities:", error))
      .finally(() => setLoadingLocalities(false));
  }, [localityInput]);


  const handleAreaUnitInputChange = (e) => {
    setAreaUnitInput(e.target.value);
    setShowAreaUnitDropdown(true);
  };

  const handleAreaUnitSelect = (areaUnit) => {
    setAreaUnitInput(areaUnit.unit_name);
    handleInputChange("projectDetails", "areaUnit", areaUnit.id);
    setShowAreaUnitDropdown(false); // Hide dropdown after selection
  };
  useEffect(() => {
    setLoadingAreaUnit(true);
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/search/areaUnit?query=${areaUnitInput}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Get token from localStorage
          },
        }
      )
      .then((response) => {
        setAreaUnit(response.data.data || []);
      })
      .catch((error) => console.error("Error fetching localities:", error))
      .finally(() => setLoadingAreaUnit(false));
  }, [areaUnitInput]);

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <div className="propjectForm">
            <div className="projectFormHeader">
              <span>Add Project Details</span>
              <span className="infoIcon">ⓘ</span>
            </div>
            <div className="formSection">
              <div className="formBodyProject">
                <div
                  className={`formRow  ${errors.projectName || errors.category ? "mb-4" : "mb-4"
                    }`}
                >
                  <div className="w-50">
                    <CustomDropdown
                      formData={formData}
                      handleInputChange={handleInputChange}
                      index={"projectDetails"}
                      field={"category"}
                      data-description="category description"
                      options={categoryOptions}
                      placeholder="Select Project Category"
                      onSelect={(value) => console.log("City:", value)}
                    />
                    {errors.category && (
                      <small className="text-danger">{errors.category}</small>
                    )}
                  </div>
                  <div className="input-container  w-50">
                    <input
                      type="text"
                      id="projectName"
                      placeholder=" "
                      className="textField"
                      value={formData.projectDetails.projectName || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "projectDetails",
                          "projectName",
                          e.target.value
                        )
                      }
                    />
                    <label
                      htmlFor="projectName"
                      data-index="projectDetails"
                      data-field="projectName"
                      data-description="projectName description"
                      className="floating-label"
                    >
                      Project Name <span className="required_field">*</span>
                    </label>
                    {errors.projectName && (
                      <small className="text-danger">
                        {errors.projectName}
                      </small>
                    )}
                  </div>
                </div>
                <div
                  className={`formRow mt-4 ${errors.city || errors.state ? "mb-5" : "mb-3"
                    }`}
                >
                  <div className="w-50">
                    <CustomDropdown
                      formData={formData}
                      handleInputChange={handleInputChange}
                      index={"projectDetails"}
                      field={"state"}
                      data-description="state description"
                      options={stateOptions}
                      placeholder="State"
                      onSelect={(value) => console.log("State:", value)}
                    />
                    {errors.state && (
                      <small className="text-danger">{errors.state}</small>
                    )}
                  </div>
                  <div className="w-50">
                    <CustomDropdown
                      formData={formData}
                      handleInputChange={handleInputChange}
                      index={"projectDetails"}
                      field={"city"}
                      data-description="city description"
                      options={cityOptions}
                      placeholder="City"
                      onSelect={(value) => console.log("city:", value)}
                    />
                    {errors.city && (
                      <small className="text-danger">{errors.city}</small>
                    )}
                  </div>
                </div>
                <div
                  className={`formRow mt-4 ${errors.totalUnit || errors.locality ? "mb-5" : "mb-3"
                    }`}
                >
                  <div className="input-container w-50">
                    <div className="input-wrapper">
                      <input
                        type="text"
                        id="localityInput"
                        placeholder=" "
                        value={localityInput}
                        onChange={handleLocalityInputChange}
                        className="textField"
                      />
                      <label htmlFor="localityInput" className="floating-label">
                        Locality <span className="required_field">*</span>
                      </label>
                    </div>

                    {loadingLocalities && (
                      <div className="loading">Loading localities...</div>
                    )}

                    {showLocalityDropdown && localities.length > 0 && (
                      <ul className="autocomplete-dropdown">
                        {localities.map((locality) => (
                          <li
                            key={locality.id}
                            className="autocomplete-item"
                            onClick={() => handleLocalitySelect(locality)}
                          >
                            {locality.name}
                          </li>
                        ))}
                      </ul>
                    )}

                    {errors.locality && (
                      <small className="text-danger">{errors.locality}</small>
                    )}
                  </div>
                  <div className="input-container w-50">
                    <input
                      type="totalUnit"
                      id="totalUnit"
                      placeholder=" "
                      className="textField"
                      value={formData.projectDetails.totalUnit || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "projectDetails",
                          "totalUnit",
                          e.target.value
                        )
                      }
                    />
                    <label
                      htmlFor="totalUnit"
                      data-index="projectDetails"
                      data-field="totalUnit"
                      className="floating-label"
                    >
                      Total Unit
                    </label>
                    {errors.totalUnit && (
                      <small className="text-danger">{errors.totalUnit}</small>
                    )}
                  </div>
                </div>
                <div
                  className={`formRow mt-4 ${errors.launchDate || errors.reraId ? "mb-5" : "mb-3"
                    }`}
                >
                  <div className="input-container w-50">
                    <input
                      type="date"
                      id="launchDate"
                      placeholder=" "
                      className="textField"
                      value={formData.projectDetails.launchDate || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "projectDetails",
                          "launchDate",
                          e.target.value
                        )
                      }
                    />
                    <label
                      htmlFor="launchDate"
                      data-index="projectDetails  "
                      data-field="launchDate"
                      className="floating-label"
                    >
                      Launch Date
                    </label>
                    {errors.launchDate && (
                      <small className="text-danger">{errors.launchDate}</small>
                    )}
                  </div>

                  <div className="input-container w-50">
                    <input
                      type="reraId"
                      id="reraId"
                      placeholder=" "
                      className="textField"
                      value={formData.projectDetails.reraId || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "projectDetails",
                          "reraId",
                          e.target.value
                        )
                      }
                    />
                    <label
                      htmlFor="reraId"
                      data-index="projectDetails"
                      data-field="reraId"
                      className="floating-label"
                    >
                      Rera Id
                    </label>
                    {errors.reraId && (
                      <small className="text-danger">{errors.reraId}</small>
                    )}
                  </div>
                </div>
                <div
                  className={`formRow mt-4 ${
                    errors.areaUnit || errors.projectArea
                      ? "mb-5"
                      : "mb-3"
                    }`}
                >
                  <div className="input-container  w-50">
                    <input
                      type="text"
                      id="projectArea"
                      placeholder=" "
                      className="textField"
                      value={formData.projectDetails.projectArea || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "projectDetails",
                          "projectArea",
                          e.target.value
                        )
                      }
                    />
                    <label
                      htmlFor="projectArea"
                      data-index="projectDetails"
                      data-field="projectArea"
                      data-description="projectArea description"
                      className="floating-label"
                    >
                      Project Area
                    </label>
                    {errors.projectArea && (
                      <small className="text-danger">
                        {errors.projectArea}
                      </small>
                    )}
                  </div>
                
                  <div className="input-container w-50">
                    <div className="input-wrapper">
                      <input
                        type="text"
                        id="areaUnitInput"
                        placeholder=" "
                        value={areaUnitInput}
                        onChange={handleAreaUnitInputChange}
                        className="textField"
                      />
                      <label htmlFor="areaUnitInput" className="floating-label">
                        Area Unit
                      </label>
                    </div>

                    {loadingAreaUnit && (
                      <div className="loading">Loading area unit...</div>
                    )}

                    {showAreaUnitDropdown && areaUnit.length > 0 && (
                      <ul className="autocomplete-dropdown">
                        {areaUnit.map((unit) => (
                          <li
                            key={unit.id}
                            className="autocomplete-item"
                            onClick={() => handleAreaUnitSelect(unit)}
                          >
                            {unit.unit_name}({unit.short_name})
                          </li>
                        ))}
                      </ul>
                    )}

                    {errors.areaUnit && (
                      <small className="text-danger">{errors.areaUnit}</small>
                    )}
                  </div>
                </div>
                <div
                  className={`formRow mt-4 ${
                    errors.projectDescription
                      ? "mb-5"
                      : "mb-3"
                  }`}
                >
                  <div className="input-container w-50">
                    <input
                      type="text"
                      id="projectDescription"
                      placeholder=" "
                      className="textField"
                      value={formData.projectDetails.projectDescription || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "projectDetails",
                          "projectDescription",
                          e.target.value
                        )
                      }
                    />
                    <label
                      htmlFor="projectDescription"
                      data-index="projectDetails"
                      data-field="projectDescription"
                      className="floating-label"
                    >
                      Project Description{" "}
                      <span className="required_field">*</span>
                    </label>
                    {errors.projectDescription && (
                      <small className="text-danger">
                        {errors.projectDescription}
                      </small>
                    )}
                  </div>
                </div>
              </div>
              <div className="formFooter">
                <div
                  className="footerButton"
                  onClick={() => handleSubmitDetail()}
                >
                  <button className="nextText">Next</button>
                </div>
              </div>
            </div>
          </div>
        );

      case 1:
        return (
          <div className="propjectForm">
            <div className="projectFormHeader">
              <span>Add Photos/Videos</span>
              <div>
                <button
                  className="rbButtonProject"
                  onClick={() => handleSkip()}
                >
                  {images.length >= 1 ? "Next" : "Skip"}{" "}
                  <span className={images.length >= 1 ? "arrow1" : ""}>
                    &gt;&gt;
                  </span>
                </button>
              </div>
            </div>
            <div className="formSection">
              <div className="formBodyProject">
                <div>
                  <div className="imagePreview">
                    {images.map((image, index) => (
                      <div key={index} style={{ width: "90px" }}>
                        <img
                          src={image.image_url}
                          className="rbox"
                          alt={`Uploaded ${index}`}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = noImage;
                          }}
                        />
                        <button
                          className="delete-button btn"
                          onClick={() => handleDelete(index, image.id)}
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_2785_1188)">
                              <path
                                d="M7.64199 12.3587L12.3587 7.64199M12.3587 12.3587L7.64199 7.64199M10.0003 18.3337C14.5837 18.3337 18.3337 14.5837 18.3337 10.0003C18.3337 5.41699 14.5837 1.66699 10.0003 1.66699C5.41699 1.66699 1.66699 5.41699 1.66699 10.0003C1.66699 14.5837 5.41699 18.3337 10.0003 18.3337Z"
                                stroke="#B7B7B7"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_2785_1188">
                                <rect width="20" height="20" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </button>
                        {/* <div className="image-dropdown">
                          {image.image_url.toLowerCase().endsWith(".pdf") ? (
                            // Dropdown for PDFs
                            <select
                              className="image-dropdown1"
                              onChange={(e) =>
                                handleCategory(image.id, e.target.value)
                              }
                            >
                              <option value="">Select</option>
                              <option value="brochure">Brochure</option>
                            </select>
                          ) : (
                            // Dropdown for images
                            <select
                              className="image-dropdown2"
                              onChange={(e) =>
                                handleCategory(image.id, e.target.value)
                              }
                            >
                              <option value="">Select</option>
                              <option value="cover">Cover</option>
                              <option value="living">Living Room</option>
                              <option value="kitchen">Kitchen</option>
                              <option value="bathroom">Bathroom</option>
                              <option value="dining room">Dining Room</option>
                              <option value="laundary room">
                                Laundry Room
                              </option>
                              <option value="bedroom">Bedroom</option>
                              <option value="balcony">Balcony</option>
                              <option value="front view">Front View</option>
                              <option value="garden">Garden</option>
                              <option value="terrace">Terrace</option>
                              <option value="rooftop">Rooftop</option>
                              <option value="parking area">Parking Area</option>
                              <option value="swimming pool">
                                Swimming Pool
                              </option>
                              <option value="gym">Gym </option>
                              <option value="play area">Play Area </option>
                              <option value="lift / staircase">
                                Lift / Staircase{" "}
                              </option>
                              <option value="office space">Office Space</option>
                              <option value="meeting / conference room">
                                Meeting / Conference Room
                              </option>
                              <option value="retail / shop area">
                                Retail / Shop Area
                              </option>
                              <option value="warehouse">Warehouse</option>
                              <option value="reception">Reception</option>
                              <option value="prayer room">Prayer Room</option>
                            </select>
                          )}
                        </div> */}
                      </div>
                    ))}
                  </div>
                  <div
                    className="insbox"
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}
                  >
                    <p>Drag & Drop here</p>
                    <p>or</p>

                    <label for="file-upload" className="image-label-project">
                      Browse
                    </label>
                    <input
                      type="file"
                      id="file-upload"
                      className="instext"
                      multiple
                      onChange={(e) => handleFileChange(e)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      case 2:
        return (
          <div className="propjectForm">
            <div className="projectFormHeader">
              <span>Verify your Property</span>
              <div className="procedureButton">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.375 3.875V4.6675C11.7487 4.88375 12 5.2875 12 5.75C12 6.44 11.44 7 10.75 7C10.06 7 9.5 6.44 9.5 5.75C9.5 5.2875 9.75125 4.88375 10.125 4.6675V4.1875C10.125 3.67 9.705 3.25 9.1875 3.25C8.67 3.25 8.25 3.67 8.25 4.1875V9.5V9.50812C8.24563 10.8844 7.12687 12 5.75 12C4.37 12 3.25 10.88 3.25 9.5V9.39313C2.52188 9.13563 2 8.44063 2 7.625C2 6.59 2.84 5.75 3.875 5.75C4.91 5.75 5.75 6.59 5.75 7.625C5.75 8.44063 5.22813 9.13563 4.5 9.39313V9.50375C4.5 9.5675 4.505 9.63125 4.515 9.69438C4.53063 9.79437 4.55875 9.89313 4.59812 9.98625C4.65875 10.13 4.74687 10.2619 4.85562 10.3731C4.96 10.48 5.08313 10.5681 5.21875 10.6313C5.335 10.6863 5.45937 10.7231 5.58687 10.7394C5.72375 10.7575 5.86312 10.7525 5.99812 10.7256C6.11438 10.7019 6.2275 10.6619 6.3325 10.6063C6.45625 10.5406 6.56938 10.4544 6.665 10.3513C6.75938 10.25 6.83625 10.1337 6.8925 10.0075C6.93625 9.90875 6.9675 9.80438 6.98438 9.69813C6.995 9.6325 7 9.56625 7 9.5V4.1875C7 2.98 7.98 2 9.1875 2C10.2887 2 11.2006 2.81562 11.3525 3.875H11.375ZM3.875 7C3.53 7 3.25 7.28 3.25 7.625C3.25 7.97 3.53 8.25 3.875 8.25C4.22 8.25 4.5 7.97 4.5 7.625C4.5 7.28 4.22 7 3.875 7Z"
                    fill="#1B4E9B"
                  />
                </svg>
                <p>Procedure</p>
              </div>
            </div>
            <div className="formSection">
              <div className="formBodyProject">
                <p className="verifyDetailText">
                  We will visit the project to verify it. Schedule the date and
                  we'll get back to you first on call then on location. Please
                  be on location at the scheduled date and time.
                </p>
                <div className="dttim d-flex justify-content-between">
                  <div className="d-flex">
                    <div className=' w-50' >
                    <input
                      type="date"
                      id="reminder_date"
                      placeholder="Date"
                      value={formData.projectDetails.reminder_date || ""}
                      min={new Date().toISOString().split('T')[0]}
                      onChange={(e) =>
                        handleInputChange(
                          "projectDetails",
                          "reminder_date",
                          e.target.value
                        )
                      }
                      className="verify-input"
                    />
                     {reminderErrors.reminder_date && <small className="text-danger">{reminderErrors.reminder_date}</small>}
                  
                    </div>
                    <div className=' w-50'>
                    <input
                      type="time"
                      id="reminder_time"
                      placeholder=" "
                      value={formData.projectDetails.reminder_time || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "projectDetails",
                          "reminder_time",
                          e.target.value
                        )
                      }
                      className="verify-input"
                    />
                     {reminderErrors.reminder_time && <small className="text-danger">{reminderErrors.reminder_time}</small>}
                    </div>
                  </div>
                  <div className="text-center">
                    <button
                      className="reminderButton"
                      onClick={() => handleSetReminderSubmit()}
                    >
                      Set Reminder
                    </button>
                  </div>
                </div>
              </div>

            </div>
          </div>
        );
    }
  };
  return (
    <div className="addProjectSection pt-2 pb-5">
      <div className="addProjectText pt-5">Add Your Project</div>
      <div className="addProjectBox">
        <div className="addProjectBoxLeft">
          <div className="stepTextDiv desk">
            <span className="stepText">
              3 Simple Steps will make your life much easier
            </span><br/>
            <span className="stepText">Add your project and relax</span>
            {/* <pre>{JSON.stringify(formData, null, 2)}</pre> */}
          </div>
        </div>
        <div className="addProjectBoxRight">
          <div className="stepTextDiv mob">
            <p className="stepText">
              3 Simple Steps will make your life much easier
              <br/>
              Add your project and relax
            </p>
          </div>
          <div className="stepbarproject">
            {steps.map((step, index) => (
              <React.Fragment key={index}>
                <div
                  className="stepboxproject"
                  onClick={() => handleNextStep(index)}
                >
                  <p
                    className={`steptxtproject ${activeStep > index ? "active" : ""
                      }`}
                  >
                    {step}
                  </p>

                  <div
                    className={`stepdotproject ${activeStep === index
                        ? "active"
                        : activeStep > index
                          ? "visited"
                          : ""
                      }`}
                  >
                    <div
                      className={`stepindotproject ${activeStep === index
                          ? "active"
                          : activeStep > index
                            ? "visited"
                            : ""
                        }`}
                    >
                      {activeStep > index ? (
                        <svg
                          width="14"
                          height="10"
                          viewBox="0 0 14 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1.40039 5.39981L5.13399 8.99981L12.6004 1.7998"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>

                {index < steps.length - 1 && (
                  <div
                    className={`steplineproject  ${activeStep > index ? "active" : ""
                      }`}
                  ></div>
                )}
              </React.Fragment>
            ))}
          </div>
          {renderStepContent(activeStep)}
        </div>
        {showPopup && (
          <div className="popupboxproject">
            <div className="popupproject">
              <div className="check-div-project">
                <img src={check} alt="Popup" className="check" />
              </div>
              <div className="poptxtbox">
                <h2 className="congr-text-project">
                  Congratulations! Your project is under review.
                </h2>
                <p className="congr-text-p-project mt-4">
                  Your project is added successfully. After verification this
                  project will be activated and listed here.
                </p>
                <div className="checkStatusDiv">
                  <span
                    className="congr-text-p-project"
                    style={{ margin: 0, width: "auto" }}
                  >
                    You may check the status of your projects from the
                  </span>
                  <button className="dashboardButton">Dashboard</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddProject;
